import { getAppEnvVars } from './env-vars.utils';

/**
 * Returns a typed object containing all the env vars for the app (from the `next.env-vars.js` file)
 */
export const ENV = getAppEnvVars();
